import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import LoginPage from "../layouts/LoginPage";

const indexRoutes = [
    { path: "/login", component: LoginPage },
    { path: "/dashboard", component: Dashboard },
    { path: "/livetracking", component: Dashboard },
    { path: "/pastorders", component: Dashboard },
    { path: "/", component: LoginPage }

];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/index.jsx